import { useNavComponentManager } from './useNavComponentManager';

/**
 * Please consider alternative solutions that don't require relying
 * on the component's internal state whenever possible.
 * @returns Internal component's state
 */
export const useComponentState = () => {
  const {
    state
  } = useNavComponentManager();
  return state;
};